/* =========================================================
   It Hasn't Been Easy — interactions (Shopify theme build)
   Vanilla JS, no dependencies. Degrades gracefully.
   ========================================================= */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* =========================================================
     CHECKOUT — set from Shopify theme settings (Online Store →
     Themes → Customize → Theme settings → Checkout). Paste the
     cart permalink (e.g. /cart/VARIANT_ID:1) and every
     "Get the Book" button takes the reader straight to checkout.
     Blank = buttons glide down to the book section.
     ========================================================= */
  var CHECKOUT_URL = (window.CHECKOUT_URL || "").trim();

  if (CHECKOUT_URL) {
    document.querySelectorAll("[data-buy]").forEach(function (el) {
      el.setAttribute("href", CHECKOUT_URL);
    });
  }

  /* ---- Footer year ---- */
  var yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---- Sticky nav: add hairline once scrolled ---- */
  var nav = document.querySelector(".nav");
  function onScroll() {
    if (nav) nav.classList.toggle("is-scrolled", window.scrollY > 12);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---- Mobile menu ---- */
  var toggle = document.querySelector(".nav__toggle");
  var menu = document.getElementById("mobile-menu");
  if (toggle && menu) {
    function setMenu(open) {
      toggle.setAttribute("aria-expanded", String(open));
      menu.hidden = !open;
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    }
    toggle.addEventListener("click", function () {
      setMenu(toggle.getAttribute("aria-expanded") !== "true");
    });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) setMenu(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
        setMenu(false);
        toggle.focus();
      }
    });
  }

  /* ---- Scroll reveals ---- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---- Gentle hero parallax (skipped if reduced motion) ---- */
  var cover = document.querySelector(".hero__cover");
  if (cover && !reduceMotion) {
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < 700) cover.style.transform = "translateY(" + (y * 0.04) + "px)";
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- Email signup (front-end only until the Shopify list is connected) ---- */
  var form = document.getElementById("signup-form");
  var msg = document.getElementById("signup-msg");
  if (form && msg) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = document.getElementById("email");
      var value = (input.value || "").trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!valid) {
        msg.textContent = "Please enter a valid email address.";
        input.focus();
        return;
      }
      msg.textContent = "Thank you — you're on the list.";
      form.reset();
    });
  }
})();
